import { render } from "./AppFooter.vue?vue&type=template&id=65335acf&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=65335acf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-65335acf"

export default script